import React, { Component } from 'react';
import { translate } from '../translations/translations.js';
import { translateCountry } from '../translations/countryTranslations.js';

class WelcomeForm extends Component {

  handleSubmit = (event) => {
    event.preventDefault(); 
    this.props.onNavigate();
  };

  render() {
    const { language } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <header className='form-header welcome-text'>
          {translate('welcomePrompt', language).map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
        </header>
        <button type="submit">OK</button>
      </form>
    );
  }
}

export default WelcomeForm;
